"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const onboarding_context_1 = require("./onboarding-context");
const onboarding_1 = require("@atlaskit/onboarding");
class ManagedSpotlight extends React.Component {
    componentDidMount() {
        if (this.props.step === 0) {
            this.props.registerOnboardingFlow(this.props.id);
        }
    }
    componentWillUnmount() {
        if (this.props.step === 0) {
            this.props.unregisterOnboardingFlow(this.props.id);
        }
    }
    componentDidUpdate() {
        const { id, step, currentSpotlight, spotlightDidRender } = this.props;
        if (currentSpotlight === `${id}-${step}`) {
            spotlightDidRender();
        }
    }
    render() {
        const { id, step, isLast, onboardingProps, currentSpotlight, endFlow, setStep, children } = this.props;
        const { actions } = onboardingProps;
        const name = `${id}-${step}`;
        return (React.createElement(React.Fragment, null,
            React.createElement(onboarding_1.SpotlightTarget, { name: name }, children),
            currentSpotlight === name && (React.createElement(onboarding_1.Spotlight, Object.assign({}, onboardingProps, { target: name, actions: [
                    ...(isLast
                        ? [
                            {
                                onClick: () => {
                                    if (actions && actions.onNext) {
                                        actions.onNext(this.props);
                                    }
                                    endFlow(id);
                                },
                                text: "Done"
                            }
                        ]
                        : [
                            {
                                onClick: () => {
                                    if (actions && actions.onSkip) {
                                        actions.onSkip(this.props);
                                    }
                                    endFlow(id);
                                },
                                text: "Skip"
                            },
                            {
                                onClick: () => {
                                    if (actions && actions.onNext) {
                                        actions.onNext(this.props);
                                    }
                                    setStep(step + 1);
                                },
                                text: "Next"
                            }
                        ])
                ] })))));
    }
}
function createOnboardingFlow(id, steps) {
    return steps.map((onboardingProps, index) => props => (React.createElement(onboarding_context_1.OnboardingContext.Consumer, null, onboardingContext => (React.createElement(ManagedSpotlight, Object.assign({}, props, { id: id, onboardingProps: onboardingProps, step: index, isLast: index === steps.length - 1 }, onboardingContext))))));
}
exports.createOnboardingFlow = createOnboardingFlow;
